export function tableCellCentered(width = 100) {
  return {
    textAlign: 'center',
    width,
  }
}

export function tableCellCenteredWithPercentage(width = 100) {
  return {
    textAlign: 'center',
    width: `${width}%`,
  }
}
